export var RelationshipWithProperty;
(function (RelationshipWithProperty) {
    RelationshipWithProperty["Owner"] = "OWNER";
    RelationshipWithProperty["InterestedToBuy"] = "INTERESTED_TO_BUY";
    RelationshipWithProperty["CurrentlyRenting"] = "CURRENTLY_RENTING";
    RelationshipWithProperty["Curious"] = "JUST_CURIOUS";
})(RelationshipWithProperty || (RelationshipWithProperty = {}));
//# sourceMappingURL=index.js.map